module.exports = __webpack_public_path__ + "static/lion-2a9b8bc0b890c762be207d71dc7186b4.png";